import styled from "styled-components";

export const Text = styled.div`
  text-transform: capitalize;
`;

export const Title = styled.div`
  margin: 10px 0;
`;
